const paymentGateway = require('../common/payment-gateway');

const init = () => {
	paymentGateway.init({
		braintreeConfig: {
			containerId: '#gateway-container',
			submitBtnSelector: '#submitReplaceCard',
			venmo: {
				allowNewBrowserTab: true //set this to false in places where refreshing the page would break it (like a SPA)
			},
			paypal: {
				flow: 'vault'
			},
			applePay: {
				displayName: window.iq.company_name,
				paymentRequest: {
					total: {
						label: 'Membership Fees'
					}
				}
			},
			googlePay: {
				transactionInfo: {
					totalPriceStatus: 'ESTIMATED',
					totalPrice: '1.00' //placeholder amount to allow tokenization
				}
			}
		},
		spreedlyConfig: {
			company_name: window.iq.company_name,
			submit_label: 'Save New Card',
			sidebar_top_description: '',
			sidebar_bottom_description: 'This card will be used for membership payments'
		}
	});

	window.jQuery('#replaceCard').on('submit', function (e) {
		e.preventDefault;

		if (window.jQuery('#paymentToken').val().trim().length === 0) {
			paymentGateway.update({
				amountDisplay: null,
				fullName: window.jQuery('#newFirstName').val() + ' ' + window.jQuery('#newLastName').val(),
				street1: window.jQuery('#billingStreet1').val(),
				street2: window.jQuery('#billingStreet2').val(),
				city: window.jQuery('#billingCity').val(),
				state: window.jQuery('#billingState').val(),
				postalCode: window.jQuery('#billingPostalCode').val(),
				nation: window.jQuery('#billingNation').val()
			});
			paymentGateway.tokenize();

			return false;
		}

		return true;
	});
};

module.exports = { init };
